export default __webpack_public_path__ + "static/media/Funding.2b033b94.svg";